import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-myprofile-right-tips",
  "use": "icon-myprofile-right-tips-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-myprofile-right-tips\">\n<rect opacity=\"0.01\" width=\"12\" height=\"12\" fill=\"white\" />\n<path d=\"M4 10L8 6.01L4 2\" stroke=\"#F72626\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol